import { Component, OnInit} from "@angular/core";
import { MatDialog} from "@angular/material/dialog";
import { Router } from "@angular/router";
import { MsalBroadcastService } from "@azure/msal-angular";
import { EventMessage, EventType } from "@azure/msal-browser";
import { SharedService } from "@shared/services/shared.service";
import { AuthService } from "@shared/auth/auth.service";
import { filter } from "rxjs/operators";

interface IWelcomeDialogModel {
  route: string;
  icon: string;
  title: string;
  description: string;
  backgroundColor: string;
}

@Component({
  selector: "app-welcome",
  templateUrl: "./welcome.component.html",
  styleUrls: ["./welcome.component.scss"]
})

export class WelcomeComponent implements OnInit {
  defaultRoute: string = 'welcome';
  homeRoute: string = 'home';
  route: string = 'route';
  redirectFromProfile: string = 'redirectFromProfile';
  loggingIn: boolean = false;

  constructor(
    private router: Router,
    public sharedService: SharedService,
    private authService: AuthService,
    public dialog: MatDialog,
    private msalBroadcastService: MsalBroadcastService) { }

  ngOnInit(): void {
    if(this.authService.isAuthenticated()){
      this.loggingIn = true;
      this.authService.loadUserInformation();
      this.router.navigateByUrl(this.homeRoute);
    }
    else{
      // console.log('User is NOT authenticated');
      this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
      )
      .subscribe({
        next: () => {
          this.loggingIn = true;
          this.authService.loadUserInformation();
          this.router.navigateByUrl(this.homeRoute);
        },
        error: (error) => {
          console.error('Error during login: ', error);
          this.router.navigateByUrl(this.defaultRoute);
        }
      });
    }
  }

  login(): void{
    window.localStorage.setItem(this.redirectFromProfile, 'true');
    this.authService.login();
  }


  loginRedirect(redirect: string): void {
    if (redirect == 'cancel' || redirect == null || redirect == '') {
      return;
    }
    window.localStorage.setItem(this.route, redirect);
    this.authService.login();
  }

}


